<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader v-if="active_tab!=5 && active_tab!=2 && active_tab!=3 && active_tab!=4 && active_tab!=6 " class="p-1">
            <CRow>
              <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

                <strong v-if="status_form==0">{{ $t("BaseSettings") }}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">



              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>
            <BTabs :active-tab.sync="active_tab" >
              <BTab v-if="has_permission('CompanyInfo')" :title="$t('Company')">
                <Company/>
              </BTab>
              <BTab v-if="has_permission('AccountingInfo')" :title="$t('Accounting')">
                <Accounting/>
              </BTab>

              <BTab v-if="has_permission('NumberingSettings')" :title="$t('Numbering')">
                <NumberingSettings/>
              </BTab>
              <BTab v-if="has_permission('PermissionSettings')" :title="$t('Permissions')">
                <PermissionGroups/>
              </BTab>

              <BTab v-if="has_permission('MessagesSetting') && get_access('messages')" :title="$t('messages')">
                <MessagesSetting/>
              </BTab>
<!--              <CTab v-if="has_permission('Help') && get_access('help')" :title="$t('Help')"></CTab>-->

            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import BTabs from "../../tabs/BTabs";
import Company from "./Company";
import Accounting from "./Accounting";
import PermissionGroups from "../users/PermissionGroups";
import NumberingSettings from "./NumberingSettings";
import MessagesSetting from "./MessagesSetting";
import BTab from "../../tabs/BTab";
export default {
  name: 'Login',
  components: {
    BTab,
    BTabs,
    Company,
    Accounting,
    PermissionGroups,
    NumberingSettings,
    MessagesSetting
  },
  data() {
    return {


      active_tab:parseInt(localStorage.getItem("setting_active_tab",0)),

      status_form: 0
    }
  }, mounted() {
    this.$root.root_validate_errors = [];

  }, watch: {

    'active_tab': function () {
      localStorage.setItem("setting_active_tab",this.active_tab)
    }
  },
  methods: {

  }
}

</script>
